<template>
    <div id="root">
        <main id="main">
            <slot />
        </main>
    </div>
</template>
